<ng-container *ngIf="!isGameWon && !isGameLost">

  <p class="mb-2">{{ I18ns.melo.letters }}</p>

  <div class="letters mb-2">

    <div *ngFor="let lb of letters" class="letter" [ngClass]="{ found: lb.found }">
      {{ lb.letter }}
    </div>
  </div>

  <div class="top mb-2">
    <div [style.background-image]="getPieColor()" class="pie"></div>
  </div>

  <div (click)="setLine(i)" *ngFor="let line of cells; let i = index" class="cells pointer mb-2">
    <div *ngFor="let cell of line; let j = index" [class]="i === lineIndex && j === cellIndex ? 'current' : ''"
         class="cell-square">
      <div class="cell">
        {{ cell.display }}
      </div>
    </div>
  </div>

  <p class="mb-2">{{ I18ns.melo.pickLine }}</p>
  <p class="counter mb-2">{{ I18ns.grid.words }} ({{ wordIndex + '/' + dictionary.length }})</p>

  <app-keyboard (key)="keyPressed($event)" [greyedKeys]="history"></app-keyboard>
</ng-container>

<div *ngIf="isGameLost" class="game-finished">
  <h2>
    {{ I18ns.grid.tooBad }}
  </h2>
  <p>
    {{ I18ns.grid.gameLost }}
  </p>
  <p class="answer">
    {{ words.join(' & ') }}
  </p>

  <p>&nbsp;</p>
</div>

<div *ngIf="isGameWon" class="game-finished">
  <h2>
    {{ I18ns.grid.congratulations }}
  </h2>
  <p>
    {{ I18ns.grid.finished }}
  </p>

  <p>&nbsp;</p>
  <app-themes></app-themes>
</div>
